let mailto_link_started = false;

export class MailtoLink {
  static start() {
    if (!mailto_link_started) {
      mailto_link_started = true;

      // $(document).on('click', 'a[target="_blank"][href^="mailto:"]', (event) => { MailtoLink.handle_mailto_link(event) })
      // thank you swagger ... --MZ
      $(document).on('click', 'a[href^="mailto:"]', (event) => MailtoLink.handle_mailto_link(event));
    }
  }

  static handle_mailto_link(event) {
    const $element = $(event.currentTarget);

    window.open($element.attr('href'));

    event.preventDefault();
  }
}
